import { cn } from '@/lib/utils';

interface TextLinesDisplayProps {
  lines: string[];
  className?: string;
}

/**
 * Renders an array of text lines as individual paragraphs. Used for
 * displaying multi-line content from factsheet version history such as
 * quality specifications, criteria, and calculation approaches.
 */
const TextLinesDisplay = ({ lines, className }: TextLinesDisplayProps) => {
  return (
    <>
      {lines.map((line, index) => (
        <p
          key={`${line.slice(0, 20)}-${index}`}
          className={cn('mb-0.5 text-base font-medium', className)}
        >
          {line}
        </p>
      ))}
    </>
  );
};

export default TextLinesDisplay;
